// Access helpers for the dispatcher panel (spec §5).
// RBAC items may be roles or permissions on the server; the front checks the union.

export const ACCESS = Object.freeze({
  MANAGER: 'task-manager',
  ACCOUNTANT: 'work-accountant',
  ENGINEER: 'field-engineer',
});

export function parseList(json) {
  try {
    const value = JSON.parse(json);
    return Array.isArray(value) ? value.filter((x) => typeof x === 'string') : [];
  } catch (e) {
    return [];
  }
}

export function unionItems(...lists) {
  const out = [];
  lists.forEach((list) => {
    (Array.isArray(list) ? list : []).forEach((x) => {
      if (typeof x === 'string' && !out.includes(x)) out.push(x);
    });
  });
  return out;
}

export function readAccessItems(storage = window.localStorage) {
  return unionItems(parseList(storage.getItem('roles')), parseList(storage.getItem('permissions')));
}

export function hasAccess(items, required) {
  if (!required) return false;
  const list = Array.isArray(required) ? required : [required];
  const have = Array.isArray(items) ? items : [];
  return list.some((r) => have.includes(r));
}

/** Landing route after login (KOP-40): engineers go straight to «Трекер задач». */
export function postLoginRoute(items) {
  return hasAccess(items, ACCESS.ENGINEER) ? '/field/tasks' : '/';
}

export const DISPATCHER_SECTIONS = Object.freeze([
  { key: 'map', path: 'map', routeName: 'dispatcher-map', label: 'Карта объектов', icon: 'ri-map-pin-line', access: ACCESS.MANAGER },
  { key: 'tracker', path: 'tracker', routeName: 'dispatcher-tracker', label: 'Трекер', icon: 'ri-layout-column-line', access: ACCESS.MANAGER },
  { key: 'catalog', path: 'catalog', routeName: 'dispatcher-catalog', label: 'Справочник', icon: 'ri-list-check', access: ACCESS.ACCOUNTANT },
  { key: 'expenses', path: 'expenses', routeName: 'dispatcher-expenses', label: 'Расходы', icon: 'ri-wallet-3-line', access: ACCESS.ACCOUNTANT },
]);

export function allowedSections(items) {
  return DISPATCHER_SECTIONS.filter((s) => hasAccess(items, s.access));
}

export function firstAllowedSection(items) {
  return allowedSections(items)[0] || null;
}

export function canEnter(items) {
  return allowedSections(items).length > 0;
}

export function menuItemVisible(items, item) {
  if (!item) return false;
  if (hasAccess(items, item.perm)) return true;
  return (item.subItems || []).some((child) => menuItemVisible(items, child));
}

function redirectTarget(items) {
  const first = firstAllowedSection(items);
  return first ? { name: first.routeName } : '/';
}

export function createDispatcherGuards(readItems = readAccessItems) {
  return {
    parent(to, from, next) {
      const items = readItems();
      if (!canEnter(items)) return next('/');
      return next();
    },
    section(key) {
      return (to, from, next) => {
        const items = readItems();
        const section = DISPATCHER_SECTIONS.find((s) => s.key === key);
        if (section && hasAccess(items, section.access)) return next();
        return next(redirectTarget(items));
      };
    },
    indexRedirect() {
      return redirectTarget(readItems());
    },
  };
}

export const dispatcherGuards = createDispatcherGuards();
